import { useEffect, useState } from "react";
import { ModalCustom } from "components/ModalCustom";
import {
  ModalBody,
  Subtitle,
  SwitchWrapper,
  ToggleLabel,
  ToggleRow,
} from "./style";

export interface ConfigColuna {
  nome: string;
  exibir: boolean;
}

interface IProps {
  show: boolean;
  handleClose: () => void;
  configColunas: ConfigColuna[];
  onSave: (config: ConfigColuna[]) => void;
  labels?: Record<string, string>;
  title?: string;
}

export function ModalConfigColunas({
  show,
  handleClose,
  configColunas,
  onSave,
  labels = {},
  title = "Configurar visualização de colunas",
}: IProps) {
  const [tempConfig, setTempConfig] = useState(configColunas);

  useEffect(() => {
    if (show) setTempConfig(configColunas);
  }, [show, configColunas]);

  const allSelected = tempConfig.every((c) => c.exibir);

  function toggleAll() {
    setTempConfig(tempConfig.map((c) => ({ ...c, exibir: !allSelected })));
  }

  function toggleColuna(nome: string) {
    setTempConfig(
      tempConfig.map((c) =>
        c.nome === nome ? { ...c, exibir: !c.exibir } : c,
      ),
    );
  }

  function handleSave() {
    onSave(tempConfig);
    handleClose();
  }

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={title}
      centered
      footer
      footerConfirmButton
      onConfirm={handleSave}
      confirmButtonText="Salvar"
    >
      <ModalBody>
        <Subtitle>
          Selecione as colunas que deseja visualizar na sua tabela.
        </Subtitle>
        <ToggleRow>
          <ToggleLabel bold>Colunas</ToggleLabel>
          <SwitchWrapper>
            <input type="checkbox" checked={allSelected} onChange={toggleAll} />
            <span />
          </SwitchWrapper>
        </ToggleRow>
        {tempConfig.map((col) => (
          <ToggleRow key={col.nome}>
            <ToggleLabel>{labels[col.nome] ?? col.nome}</ToggleLabel>
            <SwitchWrapper>
              <input
                type="checkbox"
                checked={col.exibir}
                onChange={() => toggleColuna(col.nome)}
              />
              <span />
            </SwitchWrapper>
          </ToggleRow>
        ))}
      </ModalBody>
    </ModalCustom>
  );
}
